__webpack_require__.p = "/ipa/livescoring/";